import styled from "styled-components";

export const ProgramConnectionContainer = styled.div``;